module.exports = __webpack_public_path__ + "img/icon_ig.d6b412f0.svg";